var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9834 18.7433C13.8028 19.2728 14.7792 19.5035 15.7484 19.3967C16.7177 19.2899 17.6207 18.8521 18.3056 18.157L18.9043 17.5707C19.1668 17.3017 19.3138 16.9406 19.3138 16.5645C19.3138 16.1885 19.1668 15.8273 18.9043 15.5584L16.363 13.0398C16.0967 12.7778 15.7384 12.6309 15.3651 12.6309C14.9918 12.6309 14.6334 12.7778 14.3671 13.0398V13.0398C14.0986 13.3027 13.7381 13.4499 13.3626 13.4499C12.9871 13.4499 12.6265 13.3027 12.358 13.0398L8.36636 9.04203C8.2332 8.9106 8.12746 8.75397 8.05528 8.58125C7.98311 8.40852 7.94594 8.22315 7.94594 8.03591C7.94594 7.84867 7.98311 7.6633 8.05528 7.49058C8.12746 7.31786 8.2332 7.16123 8.36636 7.0298V7.0298C8.62802 6.76315 8.77463 6.40423 8.77463 6.03035C8.77463 5.65648 8.62802 5.29756 8.36636 5.03091L5.83831 2.49897C5.56981 2.23607 5.20923 2.08887 4.83374 2.08887C4.45825 2.08887 4.09767 2.23607 3.82917 2.49897L3.24373 3.09864C2.54964 3.78458 2.11254 4.68896 2.00592 5.65972C1.89931 6.63047 2.12967 7.60838 2.65829 8.42903C5.41259 12.4944 8.91712 15.9953 12.9834 18.7433V18.7433Z",
    stroke: "white",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.646484 0.754883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1c1d9cf0ba6935b7998d09cfc3f94f41.svg";
export { ForwardRef as ReactComponent };